import {Card, Grid, Heading} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import type {Document} from '@contentful/rich-text-types'
import type {IconLinkItem} from '../../types'
import {renderWithoutParagraphs} from '../../utils'

export type FlexSuiteIconCardsProps = {
  heading?: Document
  cards?: IconLinkItem[]
}

export function FlexSuiteIconCards({heading, cards}: FlexSuiteIconCardsProps) {
  if (!cards?.length) return null

  return (
    <Grid>
      {heading && (
        <Grid.Column span={12}>
          <Heading as="h3">{renderWithoutParagraphs(heading)}</Heading>
        </Grid.Column>
      )}
      {cards.map(cardItem => {
        const id = cardItem.sys.id
        const card = cardItem.fields
        const IconComponent = getPrimerIcon(card.icon)

        return (
          <Grid.Column span={{small: 12, medium: 4}} key={id}>
            <Card href={card.href} fullWidth hasBorder align="start" ctaVariant="arrow" ctaText={card.label}>
              {IconComponent ? <Card.Icon icon={<IconComponent />} color="default" hasBackground /> : null}
              {card.eyebrow ? <Card.Label>{card.eyebrow}</Card.Label> : null}
              <Card.Heading>{renderWithoutParagraphs(card.heading)}</Card.Heading>
              <Card.Description>{renderWithoutParagraphs(card.description)}</Card.Description>
            </Card>
          </Grid.Column>
        )
      })}
    </Grid>
  )
}
